import { render, staticRenderFns } from "./Samples_Only.vue?vue&type=template&id=7f810777&scoped=true"
import script from "./Samples_Only.vue?vue&type=script&lang=js"
export * from "./Samples_Only.vue?vue&type=script&lang=js"
import style0 from "./Samples_Only.vue?vue&type=style&index=0&id=7f810777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f810777",
  null
  
)

export default component.exports